import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { validaMonto, formatoMonto, formatMoneda } from "../../../util/varios";

const ModalImprimirMontoDeclarado = (props) => {
  let op = require("../../../../src/modulos/datos");
  const valorDolar = JSON.parse(localStorage.getItem("valorDolar"));
  const anioActual = new Date().getFullYear();
  const anios = Array.from(new Array(7), (val, index) => anioActual - index);
  const fechaActual = new Date().toISOString().split("T")[0];
  const [tasa, setTasa] = useState();
  const [mes, setMes] = useState();
  const [anio, setAnio] = useState(anioActual);
  const [tipo, setTipo] = useState("general");
  const [tipoCambio, setTipoCambio] = useState("bs");
  const [fecha, setFecha] = useState(fechaActual);
  const [estatus, setEstatus] = useState("todos");
  const [montos, setMontos] = useState({
    desde: 0,
    hasta: 0,
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const MESES = [
    { value: "1", label: "ENERO" },
    { value: "2", label: "FEBRERO" },
    { value: "3", label: "MARZO" },
    { value: "4", label: "ABRIL" },
    { value: "5", label: "MAYO" },
    { value: "6", label: "JUNIO" },
    { value: "7", label: "JULIO" },
    { value: "8", label: "AGOSTO" },
    { value: "9", label: "SEPTIEMBRE" },
    { value: "10", label: "OCTUBRE" },
    { value: "11", label: "NOVIEMBRE" },
    { value: "12", label: "DICIEMBRE" },
  ];
  const txtTasa = useRef();
  const txtMontoDesde = useRef();
  const txtMontoHasta = useRef();
  const txtMes = useRef();
  const salir = () => {
    props.setTabla();
  };
  const blanquear = () => {
    setMes(MESES["0"]);
    setAnio(anioActual);
    setTipo("general");
    setFecha(fechaActual);
    setEstatus("todos");
    setTipoCambio("bs");
    setMontos({
      desde: 0,
      hasta: 0,
    });
  };

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (
      event.target.value === "" ||
      parseFloat(
        event.target.value.trim().replace(/\./g, "").replace(",", "."),
      ) === 0.0
    ) {
      event.target.value = "0,00";
    }
    if (event.which === 13 || typeof event.which === "undefined") {
      event.target.value = formatoMonto(event.target.value);
      let char1 = event.target.value.substring(0, 1);
      let char2 = event.target.value.substring(1, 2);
      if (char1 === "0" && char2 !== ",") {
        event.target.value = event.target.value.substring(
          1,
          event.target.value.legth,
        );
      }
      if (event.target.name === "tasaCambio") {
        /* setTasa(
          parseFloat(event.target.value.replace(/\./g, "").replace(",", ".")),
        ); */
        /* if (event.which === 13) {
          btnAcepta.current.focus();
        } */
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const imprimirReporte = () => {
    var sigue = true;
    var reporte = "";
    var sql = "";
    var sql2 = "";
    var sql3 = "";
    var sql4 = "";
    var sql5 = "";
    var sql6 = "";
    var factor = 1.00;
    // var val3;
    var condicion = "";
    if (tipoCambio === "divisa") {
      if (txtTasa.current.value === "") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "El Monto del Factor de Cambiono Debe Estar Vacío.",
          icono: "informacion",
        });
        sigue = false;
        txtTasa.current.focus();
      } else if (txtTasa.current.value === "0,00") {
        setMensaje({
          mostrar: true,
          titulo: "Notificación.",
          texto: "El Monto del Factor de Cambio no Debe ser Igual a Cero.",
          icono: "informacion",
        });
        sigue = false;
        txtTasa.current.focus();
      } else {
        factor = txtTasa.current.value.replace(/\./g, "").replace(",", ".");
      }
    }

    if (sigue) {
      if (tipo === "general") {
        reporte = "ListMontoDecl";

        sql = "anio = " + anio + " and mes = " + "'" + mes.label.trim() + "'" +
              " and DJUR.FechaDeclaracion <= '" + fecha + "'";
        sql2 = "Período de Declaración:" + " " + mes.label.trim() + " " + anio;
        // String sql3 = "cuenta";
        sql4 = "Listado General Ordenado por Sector de Cobranzas";
        sql5 = "";
        if (estatus == "todos") {
          sql5 = "true";
        } else if (estatus == "pagadas") {
          sql5 = "pagada = 'Pagada'";
        } else {
          sql5 = "pagada = 'Por Pagar'";
        }


        window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte +
            "&CONDICION=" + sql + "&CONDICION2= true" + "&CONDICION3=" + sql5 + "&TIT_RGO1=" + sql2 +
            "&TIT_ADICIONAL=" + sql4 + "&FACTOR=" + factor,
          "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",);
      } else if (tipo === "declaracion") {
        reporte = "ListMontoDeclRet";

        sql = "anio = " + anio + " and mes = " + "'" + mes.label.trim() + "'";
        sql2 = "Período de Declaración:" + " " + mes.label.trim() + " " + anio;
        // String sql3 = "cuenta";
        sql4 = "Listado General Ordenado por Sector de Cobranzas";
        sql5 = "";
        if (estatus == "todos") {
          sql5 = "true";
        } else if (estatus == "pagadas") {
          sql5 = "pagada = 'Pagada'";
        } else {
          sql5 = "pagada = 'Por Pagar'";
        }


        window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte +
            "&CONDICION=" + sql + "&CONDICION3=" + sql5 + "&TIT_RGO1=" + sql2 +
            "&TIT_ADICIONAL=" + sql4 + "&FACTOR=" + factor,
          "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",);
      } else if (tipo === "historico") {
        reporte = "DeclaHist";

        sql = "anio = " + anio + " and mes = " + "'" + mes.label.trim() + "'";
        sql2 = "Período de Declaración:" + " " + mes.label.trim() + " " + anio;
        // String sql3 = "cuenta";
        sql4 = "Listado General Ordenado por Sector de Cobranzas";
        sql5 = "";
        if (estatus == "todos") {
          sql5 = "true";
        } else if (estatus == "pagadas") {
          sql5 = "pagada = 'Pagada'";
        } else {
          sql5 = "pagada = 'Por Pagar'";
        }


        window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte +
            "&CONDICION=" + sql + "&CONDICION3=" + sql5 + "&TIT_RGO1=" + sql2 +
            "&TIT_ADICIONAL=" + sql4 + "&FACTOR=" + factor + "&ANIO=" + anio,
          "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",);
      } else {
        reporte = "ListMontoDecl";
        let montoDesde = parseFloat(txtMontoDesde.current.value.replace(/\./g, "").replace(",", "."));
        let montoHasta = parseFloat(txtMontoHasta.current.value.replace(/\./g, "").replace(",", "."));
        
        sql = "anio = " + anio + " and mes = " + "'" + mes.label.trim() + "'";
        sql2 = "Período de Declaración:" + " " + mes.label.trim() + " " + anio;
        sql3 = "Desde:" + " " + txtMontoDesde.current.value.trim()
											+ " " + "Hasta:" + " "
											+ txtMontoHasta.current.value.trim();
        sql4 = " nMONTOD " + " between" + "'" + montoDesde + "'" + "and" + "'" + montoHasta + "'";
        sql5 = "";
        if (estatus == "todos") {
          sql5 = "true";
        } else if (estatus == "pagadas") {
          sql5 = "pagada = 'Pagada'";
        } else {
          sql5 = "pagada = 'Por Pagar'";
        }


        window.open(op.reportes + "/actividadeconomica?" + "reporte=" + reporte +
            "&CONDICION=" + sql + "&CONDICION2=" + sql4 + "&CONDICION3=" + sql5 + "&TIT_RGO1=" + sql2 +
            "&TIT_ADICIONAL=" + sql3 + "&FACTOR=" + factor,
          "Planilla", "fullscreen=no,scrollbars=yes,toolbar=no,resizable=no,width=850,height=700",);
      }
    }
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgba(0, 0, 0, 0.521)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        blanquear();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-5 fw-bold text-light m-0">
          Listado Contribuyentes por Montos Declarados
        </h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex justify-content-between col-md-12">
          <fieldset className="col-md-12 row mb-2 border-azul row rounded">
            <legend
              className="float-none w-auto fw-bold text-uppercase"
              style={{
                fontSize: "0.9rem",
              }}
            >
              Tipo de Reporte
            </legend>
            <div className="col-md-12 row d-flex justify-content-center align-items-center">
              <div className="form-check col-md-3 d-flex align-items-center">
                <label className="form-check-label">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="tipoReporte"
                    value="general"
                    checked={tipo === "general"}
                    onChange={(e) => setTipo(e.target.value)}
                  />
                  General
                </label>
              </div>
              <div className="form-check col-md-3 d-flex align-items-center">
                <label className="form-check-label">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="tipoReporte"
                    value="rango"
                    checked={tipo === "rango"}
                    onChange={(e) => setTipo(e.target.value)}
                  />
                  Rango de Montos
                </label>
              </div>
              <div className="form-check col-md-3 d-flex align-items-center">
                <label className="form-check-label">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="tipoReporte"
                    value="historico"
                    checked={tipo === "historico"}
                    onChange={(e) => setTipo(e.target.value)}
                  />
                  Histórico Anual
                </label>
              </div>
              <div className="form-check col-md-3 d-flex align-items-center">
                <label className="form-check-label">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="tipoReporte"
                    value="declaracion"
                    checked={tipo === "declaracion"}
                    onChange={(e) => setTipo(e.target.value)}
                  />
                  Declararon / Retenciones
                </label>
              </div>
            </div>
          </fieldset>
        </div>
        <div className="d-flex justify-content-between col-md-12">
          <fieldset className="col-md-12 row mb-2 border-azul row rounded">
            <legend
              className="float-none w-auto fw-bold text-uppercase"
              style={{
                fontSize: "0.9rem",
              }}
            >
              Período de Declaracion
            </legend>
            <div className="col-md-12 row d-flex justify-content-between">
              <div className="col-md-3 row py-2">
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Año
                  </span>
                  <select
                    className="form-select form-select-sm"
                    value={anio}
                    onChange={(e) => setAnio(e.target.value)}
                  >
                    {anios &&
                      anios.map((e) => (
                        <option key={e} value={e}>
                          {e}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              {tipo !== "historico" && (
                <>
                  <div className="col-md-4 row py-2">
                    <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                      <span
                        className="input-group-text text-uppercase"
                        id="inputGroup-sizing-sm"
                      >
                        Mes
                      </span>
                      <select
                        className="form-select form-select-sm"
                        ref={txtMes}
                        //value={mes}
                        onChange={(e) => {
                          let nmes = MESES.find((m) => m.value === e.target.value);
                          setMes({value: e.target.value, label: nmes.label});
                        }} 
                        autoFocus
                      >
                        {MESES.map((m) => (
                          <option key={m.value} value={m.value}>
                            {m.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4 row py-2" style={{ visibility: tipo === "general" ? "visible" : "hidden" }}>
                    <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                      <span
                        className="input-group-text text-uppercase"
                        id="inputGroup-sizing-sm"
                      >
                        al Dia:
                      </span>
                      <input
                        type="date"
                        className="form-control text-uppercase"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-sm"
                        max={fechaActual}
                        value={fecha}
                        onChange={(e) => {
                          const { value } = e.target;
                          setFecha(value);
                        }}
                      />
                    </div>
                  </div>
                </>
              )}
              <div className="col-md-4 row py-2" style={{ visibility: tipo === "historico" ? "hidden" : "visible" }}>
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Status
                  </span>
                  <select
                    className="form-select form-select-sm"
                    value={estatus}
                    onChange={(e) => {
                      const { value } = e.target;
                      setEstatus(value);
                    }}
                  >
                    <option key={0} value={"todos"}>
                      Todos
                    </option>
                    <option key={1} value={"pagadas"}>
                      Pagadas
                    </option>
                    <option key={2} value={"xPagar"}>
                      Por Pagar
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </fieldset>
        </div>
        {(tipo === "rango") && (
          <div className="d-flex justify-content-between col-md-12">
            <fieldset className="col-md-12 row mb-2 border-azul row rounded d-flex justify-content-between">
              <legend
                className="float-none w-auto fw-bold text-uppercase"
                style={{
                  fontSize: "0.9rem",
                }}
              >
                Montos
              </legend>
              <div className="col-md-4 row py-2">
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    DESDE Monto:
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase text-end"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                    ref={txtMontoDesde}
                    defaultValue={"0,00"}
                    //value={montos.desde}
                    onChange={(e) => {
                     /* const valor = e.target.value.replace(".", ",");

                      // Si borra todo, guardamos un string vacío
                      if (valor === "") {
                        setMontos((prev) => ({
                          ...prev,
                          desde: 0,
                        }));
                        return;
                      }

                      // Si cumple con el formato de números y una coma, actualizamos el estado
                      if (/^[0-9]*,?[0-9]{0,2}$/.test(valor)) {
                        setMontos((prev) => ({
                          ...prev,
                          desde: valor,
                        }));
                      } else {
                        return;
                      } */
                    }}
                  />
                </div>
              </div>
              <div className="col-md-4 row py-2">
                <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                  <span
                    className="input-group-text text-uppercase"
                    id="inputGroup-sizing-sm"
                  >
                    Hasta Monto:
                  </span>
                  <input
                    type="text"
                    className="form-control text-uppercase text-end"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-sm"
                    onKeyUp={handleInputMontoChange}
                    onBlur={handleInputMontoChange}
                    ref={txtMontoHasta}
                    defaultValue={"0,00"}
                    //value={montos.hasta}
                    onChange={(e) => {
                      /* const valor = e.target.value.replace(".", ",");

                      // Si borra todo, guardamos un string vacío
                      if (valor === "") {
                        setMontos((prev) => ({
                          ...prev,
                          hasta: 0,
                        }));
                        return;
                      }

                      // Si cumple con el formato de números y una coma, actualizamos el estado
                      if (/^[0-9]*,?[0-9]{0,2}$/.test(valor)) {
                        setMontos((prev) => ({
                          ...prev,
                          hasta: valor,
                        }));
                      } else {
                        return;
                      } */
                    }}
                  />
                </div>
              </div>
            </fieldset>
          </div>
        )}
        <div className="d-flex justify-content-between col-md-12">
          <fieldset className="col-md-12 row mb-2 border-azul row rounded">
            <legend
              className="float-none w-auto fw-bold text-uppercase"
              style={{
                fontSize: "0.9rem",
              }}
            >
              Tipo Moneda
            </legend>
            <div className="col-md-12 row d-flex justify-content-center align-items-center">
              <div className="form-check col-md-4 d-flex align-items-center">
                <label className="form-check-label">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="cambio"
                    value="bs"
                    checked={tipoCambio === "bs"}
                    onChange={(e) => setTipoCambio(e.target.value)}
                  />
                  Bolivares
                </label>
              </div>
              <div className="form-check col-md-4 d-flex align-items-center">
                <label className="form-check-label">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="cambio"
                    value="divisa"
                    checked={tipoCambio === "divisa"}
                    onChange={(e) => setTipoCambio(e.target.value)}
                  />
                  Divisas
                </label>
              </div>
              {tipoCambio === "divisa" && (
                <div className="col-md-4 row py-2">
                  <div className="input-group input-group-sm col-md-12 p-0 m-0 mb-0">
                    <span
                      className="input-group-text text-uppercase"
                      id="inputGroup-sizing-sm"
                    >
                      Factor Cambio:
                    </span>
                    <input
                      type="text"
                      className="form-control text-uppercase text-right"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      autoComplete="off"
                      name="tasaCambio"
                      ref={txtTasa}
                      //value={tasa}
                      defaultValue={formatMoneda((valorDolar || 1).toString().replace(',', '').replace('.', ','), ',', '.', 2)}
                      onKeyUp={handleInputMontoChange}
                      onBlur={handleInputMontoChange}
                      onChange={(e) => {
                        //const valor = e.target.value.replace(".", ",");
                        // Si borra todo, guardamos un string vacío
                        /* if (valor === "") {
                          setTasa(1.00);
                          return;
                        } */
                        // Si cumple con el formato de números y una coma, actualizamos el estado
                        /* if (/^[0-9]*,?[0-9]{0,2}$/.test(valor)) {
                          setTasa(valor);
                        } else {
                          return;
                        } */
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </fieldset>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-sm rounded-pill btn btn-info col-md-2"
          onClick={imprimirReporte}
        >
          <i className="fas fa-print"></i> Imprimir
        </button>
        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
    </Modal>
  );
};

export default ModalImprimirMontoDeclarado;
